import React, {useState} from 'react';
import "./Projects.scss";
import ProjectsTab from './ProjectsTab';
import WorkHistoryTab from '../WorkHistory/WorkHistoryTab';

const tabs=[
  {
    name:"Projects",
    num:1
  },
  {
    name:"Work History",
    num:2
  }
]
const Projects = () => {

  const [activeTab, setActiveTab]=useState(1);

  return (
    <div className='projectsWrapper'>
      <div className="tabBtns">
        {
          tabs.map((tab, id)=>{
            return (<div className={`tabBtn ${tab.num===activeTab? "activetabBtn":""}`} onClick={()=>setActiveTab(tab.num)} key={id}>{tab.name}</div>)
          })
        }
      </div>
      {
        activeTab===1    &&   <ProjectsTab/>

      }
      {
        activeTab===2    &&   <WorkHistoryTab/>

      }
    </div>
  )
}

export default Projects